import { render, staticRenderFns } from "./scheduleSettings.vue?vue&type=template&id=983f07d6&"
import script from "./scheduleSettings.vue?vue&type=script&lang=js&"
export * from "./scheduleSettings.vue?vue&type=script&lang=js&"
import style0 from "./scheduleSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports